import React, { Component } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PageNotFound from "../shared/PageNotFound";
import Home from "./Home";
import { Text } from "native-base";

class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emailId: this.props.emailId,
    };
  }
  render() {
    return (
      <Text>MAin</Text>
    );
  }
}

export default Main;
